<div class="card card-w-title">
  <h1>Prodotti software</h1>
  <p-table #table [value]="prodotti$ | async" [paginator]="true" [rows]="10" [alwaysShowPaginator]="false">
    <ng-template pTemplate="header">
      <tr>
        <th>Nome prodotto</th>
        <th>Versione prodotto</th>
        <th>Produttore</th>
        <th class="col2buttons" rowspan="2">
          <button class="addButton" pButton type="button" icon="fas fa-plus" title="Aggiungi"
            (click)="openModal('new')"></button>
        </th>
      </tr>
      <tr>
        <th>
          <input pInputText type="text" placeholder="Filtra per nome prodotto..." style="width:100%"
            (input)="table.filter($event.target.value, 'nomeProdotto', 'contains')">
        </th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{ item.nomeProdotto }}</td>
        <td>{{ item.versioneProdotto }}</td>
        <td>{{ item.produttore }}</td>
        <td>
          <button pButton type="button" style="margin-right: 5px;" icon="fas fa-pen" class="p-button-warning"
            title="Modifica" (click)="openModal('edit', item)"></button>
          <button pButton type="button" icon="fas fa-times" class="p-button-danger" title="Elimina"
            (click)="removeItem(item)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="4">Nessun elemento</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="isDialogOpen" [modal]="true" [closable]="false" [closeOnEscape]="false">
  <p-header>
    <span *ngIf="editMode === 'new'">Aggiungi Prodotto</span>
    <span *ngIf="editMode === 'edit'">Modifica Prodotto</span>
  </p-header>
  <form [formGroup]="form">
    <div class="card">
      <div class="field">
        <label for="nomeProdotto">Nome prodotto*</label>
        <input id="nomeProdotto" class="w-full" type="text" pInputText formControlName="nomeProdotto">
      </div>
      <div class="field">
        <label for="versioneProdotto">Versione prodotto*</label>
        <input id="versioneProdotto" class="w-full" type="text" pInputText formControlName="versioneProdotto">
      </div>
      <div class="field">
        <label for="produttore">Produttore*</label>
        <input id="produttore" class="w-full" type="text" pInputText formControlName="produttore">
      </div>
    </div>
  </form>

  <p-footer>
    <button pButton type="button" label="Annulla" class="p-button-secondary" (click)="resetForm()"></button>
    <button pButton type="button" [label]="editMode === 'new' ? 'Aggiungi' : 'Modifica'"
      (click)="saveItem()" [disabled]="form.invalid"></button>
  </p-footer>
</p-dialog>

<p-toast key="toast" position="top-center"></p-toast>
